export { default } from "@casino/client/components/Link";
